<template>
  <button
    class="bell-btn"
    :class="{ 'bell-btn--has-unread': hasUnread }"
    @click="$emit('toggle')"
    :aria-label="ariaLabel"
    :title="ariaLabel"
  >
    <svg class="bell-btn__icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M6.5 17 L17.5 17" />
      <path d="M7.5 17 L7.5 11 C7.5 8.2 9.5 5.5 12 5.5 C14.5 5.5 16.5 8.2 16.5 11 L16.5 17" />
      <path d="M10.2 19 C10.2 20.1 11 21 12 21 C13 21 13.8 20.1 13.8 19" />
    </svg>
    <span v-if="unreadCount > 0" class="bell-btn__badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
  </button>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useNotificationsStore } from '@/store/notifications.store'

export default defineComponent({
  name: 'NotificationBell',
  emits: ['toggle'],
  setup() {
    const store = useNotificationsStore()
    const unreadCount = computed(() => store.unreadCount)
    const hasUnread = computed(() => store.hasUnread)
    const ariaLabel = computed(() =>
      hasUnread.value ? `Notifications (${unreadCount.value} unread)` : 'Notifications'
    )
    return { unreadCount, hasUnread, ariaLabel }
  },
})
</script>

<style scoped>
.bell-btn {
  position: relative;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px;
  margin: 0 !important;
  border-radius: 8px !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  color: var(--vt-c-accent-light, #b4fcda);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  transition: background 0.12s ease, color 0.12s ease;
  font-family: var(--font-sans);
  flex-shrink: 0;
}

.bell-btn__icon {
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0;
  display: block;
  stroke-width: 2;
}

.bell-btn:hover {
  background: rgba(150, 255, 201, 0.12);
  color: var(--vt-c-accent, #96ffc9);
  transform: none !important;
  box-shadow: none !important;
}

.bell-btn--has-unread {
  color: var(--vt-c-accent, #96ffc9);
}

.bell-btn--has-unread .bell-btn__icon {
  color: var(--vt-c-accent, #96ffc9);
}

.bell-btn__badge {
  position: absolute;
  top: 2px;
  right: 1px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 9px;
  background: #50e5ff;
  color: #181b2f;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 0 0 2px #181b2f;
  pointer-events: none;
}
</style>
